import { addToCartMultiple } from './_global-functions.js';

if(customElements.get("button-atc") === undefined) {
  class ButtonATC extends HTMLElement {
    constructor() {
      super();
      this.identifier = '';
      this.bisIdentifier = '';
      this.quantityIdentifier = '';
      this.variantsDomIdentifier = '';
      this.bundleIdentifier = '';
      this.triggerBy = '';
      this.activeId = 0;
      this.buttons = [];
      this.variants = [];
      this.active_variant = {};
      this.active_variant_available = false;
      this.bis_id = [];
      this.bundle_id = null;
      this.quantity = 1;

      this.promo_selector = null
      this.selectedPromo = null;
    }

    connectedCallback() {
      // Identifiers
      this.identifier = '[data-var-id]';
      this.bisIdentifier = '#SI_trigger:not(.plug-notice__notify)'; // Exclude plug-notice__notify button
      this.quantityIdentifier = '[data-quantity]';
      this.variantsDomIdentifier = '#pdp-variants';
      this.bundleIdentifier = '[data-bundle]';

      // event to be triggered for id change
      this.triggerBy = this.dataset.trigger;
      this.activeId = Number(this.dataset.varId);
      this.buttons = document.querySelectorAll(this.identifier);
      this.variants = JSON.parse(document.querySelector('#pdp-variants').textContent);
      
      // Get the first available variant as default, not the selected one
      this.active_variant = this.variants.filter(variant => variant.id === this.activeId)[0];
      this.activeId = this.active_variant.id;
      this.active_variant_available = this.active_variant.available;

      this.bis_id = document.querySelectorAll(this.bisIdentifier);

      // Search for bundle checkbox
      this.bundle_id = document.querySelector('[data-bundle]');

      // Search for 'quantity' input or default to 1
      // !! For now this will always be 1 as we don't have a quantity input
      this.quantity = document.querySelectorAll(this.quantityIdentifier);

      this.promo_selector = document.querySelector('[data-promo-selector]');

      if(this.promo_selector) {
        this.promoInit();
      } else {
        // enable button when button loads
        this.removeAttribute('disabled');
      }

      if (this.quantity.length <= 0) {
        this.quantity = 1;
      }

      // Add debouncing for variant changes
      this.variantChangeTimeout = null;
      this.isVariantChanging = false;

      // Update button data attribute to reflect first available variant
      this.setAttribute('data-var-id', this.activeId);

      if(this.triggerBy) {
        document.addEventListener(this.triggerBy, this.idChange);
      }

      this.addEventListener('click', this.addToCart);
    }

    promoInit() {
      const that = this
      this.setAttribute('data-require-promo', 'true');
      document.addEventListener("promoSelected", function (e) {

        that.selectedPromo = e.detail.promo;
        if (that.active_variant_available !== false) {
          that.removeAttribute('disabled');
        }
        document.querySelectorAll("[data-promo-warning]").forEach((warning) => {
          warning.classList.remove("promo-selector__warning--visible");
        });
      });
    }

    idChange = (e) => {
      // Set flag to prevent add-to-cart during variant change
      this.isVariantChanging = true;
      
      // Clear any existing timeout
      if (this.variantChangeTimeout) {
        clearTimeout(this.variantChangeTimeout);
      }
      
      // Debounce the variant change to ensure it's fully processed
      this.variantChangeTimeout = setTimeout(() => {
        this.active_variant = e.detail.variant;
        const id = e.detail.variant.id;
        this.active_variant_available = this.active_variant.available;
        this.buttons.forEach(button => {
          this.activeId = id;
          button.dataset.varId = id;
        });
        
        if(this.active_variant_available === false) {
          this.bis_id.forEach(id => {
            this.setButtonsAvailability(id, false, 'block', 'none');
          });
        } else {
          this.bis_id.forEach(id => {
            this.setButtonsAvailability(id, true, 'none', 'flex');
          });
        }
        
        // Allow add-to-cart after variant change is complete
        this.isVariantChanging = false;
      }, 100); // Small delay to ensure variant change is processed
    }

    disconnectedCallback() {
      // browser calls this method when the element is removed from the document
      // (can be called many times if an element is repeatedly added/removed)
      
      // Clean up timeout
      if (this.variantChangeTimeout) {
        clearTimeout(this.variantChangeTimeout);
      }
    }

    async addToCart(e) {
      e.preventDefault();
      
      // Prevent add-to-cart if variant is still changing
      if (this.isVariantChanging) {
        return;
      }
      
      if(this.hasAttribute('disabled')) {
        if(this.hasAttribute('data-require-promo') && !this.selectedPromo) {
          document.querySelectorAll("[data-promo-warning]").forEach((warning) => {
            warning.classList.add("promo-selector__warning--visible");
          });
        }
        return;
      }

      if (this.active_variant_available) {
        const items = {
          "items": [
            {
              "id": this.active_variant.id,
              "quantity": this.quantity
            },
          ]
        }

        let ids = this.bundle_id?.getAttribute('data-bundle');

        if (ids)
          ids = ids.split(',')

        if (this.bundle_id && this.bundle_id.checked) {
          ids.forEach(id => {
            items.items.push({
              "id": id,
              "quantity": 1
            })
          })
        }

        if(this.hasAttribute('data-require-promo') && this.selectedPromo) {
          items.items.push({
            "id": this.selectedPromo.variantId,
            "quantity": 1
          })
        }

        const response = await addToCartMultiple({ items: items.items });

        if(!response) {
          throw new Error('Failed to add to cart');
        }
        
        this.dispatchEvent(new CustomEvent('add-to-cart', {
          detail: {
            item: response
          },
          bubbles: true,
          cancelable: true
        }));
        

        // fetch('/cart/add.js', {
        //   method: 'POST',
        //   body: JSON.stringify(items),
        //   headers: {
        //     'Content-Type': 'application/json'
        //   }
        // })
        // .then(response => {
        //   return response.json();
        // }).then(data => {
        //   // go to cart page
        //   window.location.href = `${Shopify.routes.root}cart`;
        // })
        // .catch((error) => {
        //   console.error('Error:', error);
        // });
      }
    }

    setButtonsAvailability(id, set, idDisplay, thisDisplay) {
      id[set === true ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
      id.style.display = idDisplay;
      this.style.display = thisDisplay;
      this[set === true ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
    }
  }
  customElements.define("button-atc", ButtonATC);
}